import { ParentContext } from 'global/cnr/contexts/ParentContext';
import TreeViewer from 'global/components/viewers/TreeViewer';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import _ from 'lodash';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { Form, Icon, Label } from 'semantic-ui-react';
import { apiHandlers, apiInitialState, apiReducer } from '../../../global/cnr/reducers/ApiReducer';
import GenericButton from '../../../global/genericControls/GenericButton';
import Wrapper from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { useGolf } from '../useHelpers/useGolf';
import GolfCourse from './GolfCourse';
import { scorecardTypes } from './Scorecard';

const GolfCourseFetch = (props) => {

  let { caption, allowedUrl } = props

  const { handleUpdate_golfCourse, updating } = useGolf()

  const parentContext = useContext(ParentContext);
  const { fn_cls, fns: _fns } = parentContext ?? {}

  // golfParentContext  
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, handlers, fns } = golfParent_contexts ?? {}
  const { paps_state } = states ?? {}
  const { item_handlers } = handlers ?? {}
  const { page_fns } = fns ?? {}

  const [jsonText, setJsonText] = useState('');
  const [error, setError] = useState('');
  const [url, setUrl] = useState(allowedUrl)
  const [currentGolfCourse, setCurrentGolfCourse] = useState()

  const handleChange = (e) => {
    const value = e.target.value;
    setJsonText(value);

    try {
      const parsed = JSON.parse(value);
      setCurrentGolfCourse(parsed);
      setError('');
    } catch (err) {
      setCurrentGolfCourse(null);
      setError('Invalid JSON');
    }
  };

  // paps_state, viewItem, viewListData, page_fns
  const [api_state, api_dispatch] = useReducer(apiReducer, apiInitialState(paps_state, props.viewItem, props.viewListData, page_fns));
  const api_handlers = apiHandlers(api_dispatch)
  const { apiResult: golfCourse } = api_state ? api_state : {}

  if (!caption) { caption = 'Paste' }
  caption = _.startCase(caption)

  useEffect(() => {
    if (golfCourse) {
      const { teeBoxes, holes } = golfCourse ?? {}
      if (teeBoxes && teeBoxes.pos4) {
        teeBoxes.position4 = teeBoxes.pos4
        delete teeBoxes.pos4
      }
      if (holes) {
        _.forEach(holes, (hole) => {
          if (hole.pos4) {
            hole.position4 = hole.pos4
            delete hole.pos4
          }
        })
      }
      setCurrentGolfCourse(golfCourse)
    }
  }, [golfCourse]);

  const handleSaveGolfCourse = () => {
    handleUpdate_golfCourse({ currentGolfCourse })
  }

  const handleUrlSearch = () => fn_cls.handleGolfCourseSearch(fn_cls, url)
  // const handleGhinSearch = () => api_handlers.handleGhinSearch()
  const handleUrlChange = (e, data) => { setUrl(data.value) }

  const input = () => (
    <Form>
      <Form.Input
        icon={<Icon name='search' inverted circular link onClick={handleUrlSearch} />}
        value={url} label='Url' placeholder={'url'} onChange={handleUrlChange}
      />
    </Form>
  )

  const ta = () => {
    return <>
      <textarea
        value={jsonText}
        onChange={handleChange}
        rows={5}
        style={{ width: '100%', fontFamily: 'monospace' }}
      />
    </>
  }

  const gb = (key, caption, icon, onClick, clickOptions, opts, noE) => <GenericButton gbProps={{ key, caption, icon, onClick, clickOptions, opts, noE }} />

  const ims_holes = () => {
    const fnAlt = (item) => {
      console.log('item', item)
      return <div style={{ display: 'flex', columnGap: '1em', justifyContent: 'flex-end' }}>
        <Label size='tiny' color='blue'>{item?.par}</Label>
        <Label size='tiny' color='blue'>{item?.handicap}</Label>
      </div>
      return "H"
    }
    return <ItemMenuSquares menuItems={currentGolfCourse?.holes} imsType={_imsTypes.inline} fn_altContent={fnAlt} noItemIcon={true} />
  }

  const content = () => {
    return <div className={'paste-container'}>
      <div className={'paste-content'}>
        {currentGolfCourse && ims_holes()}
        {currentGolfCourse && <TreeViewer data={currentGolfCourse} scNames={true} />}
        {currentGolfCourse && <GolfCourse golfCourse={currentGolfCourse} scorecardType={scorecardTypes.normal} />}
      </div>
    </div>
  }

  const footer = () => <React.Fragment>
    {gb('btn-cancel', 'Cancel', 'delete', item_handlers && item_handlers.handleShow_itemSidebar, null, { color: 'grey' })}
    {gb('btn-save', 'Save', 'save', handleSaveGolfCourse, null, { disabled: !currentGolfCourse })}
  </React.Fragment>

  return <Wrapper
    header={ta()}
    content={content()}
    footer={footer()}
    updating={updating}
    css={{ header: 'padd5', footer: 'padd5 modify' }}
  />
}

export default GolfCourseFetch